import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=6be8edbd&scoped=true"
import script from "./sales.vue?vue&type=script&lang=js"
export * from "./sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be8edbd",
  null
  
)

export default component.exports